<template>
  <el-col
    :span="3"
    class="wrapper"
  >
    <custom-input-number
      v-model="Cantidad"
      style="margin-bottom: 5px"
      :settings="{
        min: 0,
        precision,
        step: 0.01,
        controls: false,
      }"
    />
    <el-date-picker
      v-model="Fecha"
      style="max-width: 100%"
      type="date"
      size="default"
      placeholder="Fecha de entrega"
      format="DD/MM/YYYY"
    />
  </el-col>
</template>

<script setup>
import { computed } from 'vue';
import CustomInputNumber from '@/shared/components/custom_input_number.vue';

const Cantidad = computed({
  get() {
    return props.delivery.Cantidad;
  },
  set(Cantidad) {
    const delivery = { ...props.delivery, Cantidad };
    emit('update-delivery', delivery);
  },
});

const Fecha = computed({
  get() {
    return props.delivery.Fecha;
  },
  set(Fecha) {
    const delivery = { ...props.delivery, Fecha };
    emit('update-delivery', delivery);
  },
});

const props = defineProps({
  precision: { type: Number, default: 0 },
  delivery: { type: Object, required: true },
});

const emit = defineEmits(['update-delivery']);
</script>

<style scoped>
.wrapper {
  padding-left: 20px;
  margin: 0;
}
</style>
